<template>
  <div class="bCard bCard--promo">
    <div class="app__title--h4 font-samsung-sharp text-wrap-balance">
      {{ t("buyout.bonus.samsung_bonus_for_buyout", {manufacturer_seo_name: capitalizeFirstLetter(manufacturerSeoName)}) }}
    </div>
    <div class="desc font-samsung-one">
      {{ t("buyout.bonus.gain_bonus", {max_buyout_bonus: useCurrency(maxBuyoutBonus),manufacturer_seo_name: capitalizeFirstLetter(manufacturerSeoName), partner_sub_brand: capitalizeFirstLetter(partnerSubBrand)}) }}
    </div>
    <v-btn
      class="mbtn mbtn--black font-samsung-one font-weight-bold"
      size="large"
      :to="localePath({name: 'partner', params: {'partner': 'samsung'}})"
    >
      {{ t("buyout.bonus.view_bonuses") }}
      <v-icon icon="sg:arrow-corner" />
    </v-btn>
  </div>
</template>

<script setup lang="ts">
import useCurrency from "cashtec-common/src/composables/useCurrency";

const { t } = useI18n();
const localePath = useLocalePath();
const { maxBuyoutBonus, manufacturerSeoName } = defineProps<{
  maxBuyoutBonus: number,
  manufacturerSeoName: string
  partnerSubBrand: string
}>();

function capitalizeFirstLetter (str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
</script>
